import { Button } from "@mui/material";
import React from "react";

interface DownloadButtonProps {
  data: any;
}

const DownloadButton: React.FC<DownloadButtonProps> = (props) => {
  const { data } = props;

  const handleDownload = () => {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "data.geojson";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return <Button onClick={handleDownload}>Download GeoJSON</Button>;
};

export default DownloadButton;
